// Firebase kütüphanelerini import et
import { initializeApp } from "firebase/app";
// YENİ: Authentication ve Firestore servislerini import et
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Senin Firebase konsolundan aldığın, projeye özel ayarların
const firebaseConfig = {
  apiKey: "AIzaSyASmi2s9zPmZ9vLaJJ7O1pVvW9MNZRMCw8",
  authDomain: "arasasafinsaat.firebaseapp.com",
  projectId: "arasasafinsaat",
  storageBucket: "arasasafinsaat.firebasestorage.app",
  messagingSenderId: "796467590394",
  appId: "1:796467590394:web:9f9c89be98bb3105d24543"
};

// Firebase'i bu ayarlarla başlat
const app = initializeApp(firebaseConfig);

// Diğer component'lerde kullanmak için Authentication (Giriş) servisini export et
export const auth = getAuth(app);

// Diğer component'lerde kullanmak için Firestore (Veritabanı) servisini export et
export const db = getFirestore(app);

// Varsayılan olarak app'i de export et (isteğe bağlı)
export default app;